<template>
  <CustomerStats :customer="profile" class="gmf-customer-stats" />
</template>

<script>
import state from '@/state';
import CustomerStats from '@/components/CustomerStats.vue';

export default {
  components: {
    CustomerStats,
  },
  name: 'MyProfileStats',
  data () {
    return {
      state,
    };
  },
  computed: {
    profile() {
      return this.state.profile;
    }
  },
};
</script>
